module.exports = __webpack_public_path__ + "static/media/10.fd46fe0b.jpg";